<!-- eslint-disable max-len -->
    <template>
  <div class="py-1">
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="addToModal"
        class="
          flex
          items-center
          justify-center
          fixed
          left-0
          bottom-0
          w-full
          h-full
          z-50
        "
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-3/4 md:w-1/3 max-h-95/100">
          <div class="flex flex-col items-start p-5">
            <section>
              <h3 class="text-lg font-semibold">Add to Segment</h3>
            </section>
            <section class="flex items-center w-full">
              <select
                class="select select-bordered w-full"
                required
                v-model="segmentId"
              >
                <option disabled="disabled" value="">Select Segment</option>
                <option
                  v-for="(item, index) in segmentOnly"
                  :value="item._id"
                  :key="index"
                >
                  {{ item.title.slice(0, 30)
                  }}{{ item.title.length > 30 ? '...' : '' }}
                </option>
              </select>
            </section>
            <section class="mt-10 w-full flex justify-center">
              <div class="mr-5">
                <button class="btn btn-primary btn-outline" @click="callback()">
                  cancel
                </button>
              </div>
              <div class="">
                <button class="btn btn-primary" @click="addStudentToSegment">
                  Add
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </transition>
    <ResponseMessage
      :openPopup="openPopup"
      :callback="handleMessagePopup"
      :mssg="mssg"
      :failedDmlist="failedSignlist"
    />
  </div>
</template>

<script>
import store from '@/store';
import ResponseMessage from '../Common/ResponseMessage.vue';

export default {
  name: 'AddToSegmentModal',
  layout: 'admin',
  store,
  components: { ResponseMessage },
  data() {
    return {
      segmentId: '',
      mssg: 'Successfully added"',
      openPopup: false,
      failedSignlist: [],
    };
  },
  computed: {
    user() {
      return store.state.user;
    },
  },
  props: [
    'addToModal',
    'callback',
    'enrolledStudents',
    'enrolled',
    'segmentOnly',
  ],
  methods: {
    handleMessagePopup() {
      this.openPopup = !this.openPopup;
    },
    async addStudentToSegment() {
      try {
        this.callback();
        store.commit('toggleLoading', true);
        const selectedStudents = [];
        for (let i = 0; i < this.enrolledStudents.length; i += 1) {
          if (this.enrolled[i] === true) {
            selectedStudents.push(this.enrolledStudents[i]);
          }
        }
        const data1 = await this.$store.dispatch('enrollMembersToCourse', {
          enrolledStudents: selectedStudents,
          segmentId: this.segmentId,
        });
        console.log(data1);
        this.mssg = 'Successfully added"';
        store.commit('toggleLoading', false);
        this.handleMessagePopup();
        this.segmentId = '';
      } catch (error) {
        console.log('enroll error', error);
        store.commit('toggleLoading', false);
        this.mssg = 'Adding students failed';
        this.handleMessagePopup();
        this.segmentId = '';
      }
    },
  },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
</style>
